module.exports = __webpack_public_path__ + "img/城市相框-1.49ba4cea.jpg";